import store from 'store';
import expirePlugin from 'store/plugins/expire';
import dayjs from 'dayjs';

store.addPlugin(expirePlugin);

const keys = {
  autocombinehint: 'auto-combine-hint',
  updatedSuccess: 'updated-success',
  updatedSuccessFromVersion: 'updated-success-from',
  updatedSuccessUnix: 'updated-success-unix',
  hideUpdatedModal: 'hide-updated-modal',
  uiConfigSettingDevice: 'ui-config-setting-device',
};

const utils = {
  setAutoCombineHint: value => store.set(keys.autocombinehint, value),
  getAutoCombineHint: () => store.get(keys.autocombinehint),
  setUpdatedSuccessFromVersion: (customerId, version) =>
    store.set(
      `${keys.updatedSuccessFromVersion}-${version}-${customerId}`,
      true
    ),
  getUpdatedSuccessFromVersion: (customerId, version) =>
    store.get(`${keys.updatedSuccessFromVersion}-${version}-${customerId}`) ||
    false,
  removeUpdatedSuccessFromVersion: (customerId, version) =>
    store.remove(
      `${keys.updatedSuccessFromVersion}-${version}-${customerId}`,
      true
    ),
  setUpdatedSuccess: customerId =>
    store.set(`${keys.updatedSuccess}-${customerId}`, true),
  getUpdatedSuccess: customerId =>
    store.get(`${keys.updatedSuccess}-${customerId}`),
  removeUpdatedSuccess: customerId => {
    store.remove(`${keys.updatedSuccess}-${customerId}`, true);
  },
  setHideUpdatedModal: (customerId, version) =>
    store.set(`${keys.hideUpdatedModal}-${customerId}-${version}`, true),
  getHideUpdatedModal: (customerId, version) =>
    store.get(`${keys.hideUpdatedModal}-${customerId}-${version}`),
  getIsHideUpdatedModalForAllVersions: function(customerId, latestVersion) {
    for (let i = 0; i <= latestVersion; i++) {
      if (this.getHideUpdatedModal(customerId, i)) return true;
    }
    return false;
  },
  removeHideUpdatedModal: (customerId, version) =>
    store.remove(`${keys.hideUpdatedModal}-${customerId}-${version}`, true),
  setUiConfigSettingDevice: (customerId, device) =>
    store.set(`${keys.uiConfigSettingDevice}-${customerId}`, device),
  getUiConfigSettingDevice: customerId =>
    store.get(`${keys.uiConfigSettingDevice}-${customerId}`) || 'pad',
};

export default utils;
